/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { Checkbox } from 'antd'
import styled from '@themes/theme'
import useRootStore from '@store/useRootStore'
import { GlobalStoreKey } from '@v2/constants/common'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { CheckboxChangeEventTarget } from 'antd/es/checkbox/Checkbox'
import { useOnUnmount } from '@utils/reactExt'

const UserPickReportWrap = styled.div`
  padding: 0 18px;
  .report-contents {
    text-align: left;
    padding: 0 9px;
    &-list {
      height: 35px;
    }
    .ant-checkbox-wrapper {
      > span {
        color: ${props => props.theme.color.modalSubTxt};
        font-size: ${props => props.theme.font.title};
        font-weight: ${props => props.theme.fontW.medium};
      }
    }

  }
  .line {
    width: 100%;
    height: 1px;
    margin: 12px auto;
    background: ${props => props.theme.color.modalBg};
  }
  .report-notice {
    text-align: center;
    color: ${props => props.theme.color.modalgray};
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.regular};
  }
`
export const AdvReportList: React.FC = observer(() => {
  const { globalStore, reportStore } = useRootStore()
  const value = globalStore.findGlobalSetting(GlobalStoreKey.USER_REPORT_TEXT_LIST).value
  const textList = JSON.parse(value)
  const textElems: React.ReactElement[] = []

  useOnUnmount(() => {
    reportStore.resetAllState()
  })

  const onChangeSelection = (event: CheckboxChangeEvent, reportText: string): void => {
    const target: CheckboxChangeEventTarget = event.target
    console.log('===================== target.checked', target.checked)
    if (target.checked) {
      reportStore.setSelectedText(reportText)
    } else {
      reportStore.removeSelectedText(reportText)
    }
  }
  for (const reportText of textList) {
    textElems.push(
      <li key={reportText} className="report-contents-list">
        <Checkbox
          onChange={(event) => onChangeSelection(event, reportText)}
        >{reportText}</Checkbox>
      </li>
    )
  }
  return (
    <UserPickReportWrap>
      <ul className="report-contents">{textElems}</ul>
      <div className="line"/>
      <p className="report-notice">
        신고 후 철회가 불가능합니다 <br/>
        신고하시겠습니까?
      </p>
    </UserPickReportWrap>
  )
})
